import { gql } from "@apollo/client";

export const GET_MASTER_DATA_RETAILER_MATCH_SOURCE_COLUMNS = gql`
  query MasterDataRetailerMatchSourceColumns {
    masterDataRetailerMatchSourceColumns {
      items {
        sourceColumn
      }
    }
  }
`;
